import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { pipes, pipeServices } from './pipes';
import { libComponents } from './components';
import { TranslateModule } from '@ngx-translate/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';

const matModules: any[] = [];
const nzModules: any[] = [
    NzPaginationModule,
    NzFormModule,
    NzInputModule,
    NzInputNumberModule,
    NzDatePickerModule,
    NzSelectModule,
    NzAutocompleteModule,
    NzRadioModule,
    NzCheckboxModule,
];

@NgModule({
    declarations: [...pipes, ...libComponents],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ...matModules,
        ...nzModules,
        TranslateModule,
        InfiniteScrollModule,
    ],
    exports: [
        ...pipes,
        ...libComponents,
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ...matModules,
        ...nzModules,
        TranslateModule,
        InfiniteScrollModule,
    ],
    providers: [...pipeServices, NzMessageService, NzModalService, DecimalPipe],
})
export class SharedModule {}
